import { css } from 'styled-components';
export default css(["p{margin:0 0 10px;}.phone-link,.email,.address{flex:1;}.phone-link{&:hover{text-decoration:underline;}}.para-line-height{line-height:28px;}"]);